import axios from "axios";

const BASE = "/api/league/leaderboard";

// Valid leaderboard kinds, matching the DRF endpoints.
export const LEADERBOARD_KINDS = ["developers", "teams", "chapters"];

// Small service wrapper around the leaderboard endpoints so components don't
// hand-roll axios calls. Returns the rows array; throws on failure.
export const LeaderboardApi = {
  async fetch(kind, { tier } = {}) {
    const params = tier ? { tier } : {};
    const res = await axios.get(`${BASE}/${kind}/`, {
      params,
      withCredentials: true,
    });
    return Array.isArray(res.data) ? res.data : [];
  },
};
